<template>
  <div class="drawerContent">
    <van-nav-bar fixed left-arrow @click-left="onClickLeft">
      <template #left>
        <van-icon name="arrow-left" size="18" color="#fff" />
      </template>
      <template #title>
        <span class="navbar_title">审批详情</span>
      </template>
    </van-nav-bar>
    <div class="nav-placeholder"></div>
    <div class="container">
      <div class="checkboxContent">
        <div class="checkboxContent_nav_bar">{{initData.unitName}}</div>
        <div class="checkboxContent_body">
          <div class="checkboxContent_body_msg">
            <div class="body_msg_title">预约人</div>
            <div class="body_msg_text">{{ initData.peopleName }}</div>
          </div>
          <div class="checkboxContent_body_msg">
            <div class="body_msg_title">申请时间</div>
            <div class="body_msg_text">
              {{ showApplyTime(initData.applyTime) }}
            </div>
          </div>
          <div class="checkboxContent_body_msg">
            <div class="body_msg_title">联系方式</div>
            <div class="body_msg_text">{{ initData.appointPeopleTel }}</div>
          </div>
          <div class="checkboxContent_body_msg">
            <div class="body_msg_title">预约时间</div>
            <div class="body_msg_text">{{ showDate(initData) }}</div>
          </div>
          <div class="checkboxContent_body_msg">
            <div class="body_msg_title">审批状态</div>
            <div class="body_msg_text">
              {{ showAppointState(initData) }}
            </div>
          </div>
          <div class="checkboxContent_body_msg">
            <div class="body_msg_title">开门方式</div>
            <div class="body_msg_text">
              {{ showOpenType(initData.openType) }}
            </div>
          </div>
          <div class="checkboxContent_body_msg">
            <div class="body_msg_title">申请原因</div>
            <div class="body_msg_text">{{ initData.appointReason }}</div>
          </div>
        </div>
      </div>
      <!-- 操作的按钮 -->
      <div class="operate">
        <van-cell-group>
          <!-- 房间 -->
          <div class="field_container">
            <van-field v-model="rejectReason" placeholder="请输入驳回/审批原因">
            </van-field>
          </div>
        </van-cell-group>
        <van-cell>
          <template #default>
            <div class="btn_items">
              <van-button
                style="border-radius: 4px"
                color="#B73F3E"
                type="info"
                block
                plain
                class="left_btn"
                @click="reject"
                >驳回</van-button
              >
              <van-button
                style="border-radius: 4px"
                color="#B73F3E"
                type="info"
                block
                class="right_btn"
                @click="appoint"
                >同意</van-button
              >
            </div>
          </template>
        </van-cell>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import md5 from "md5";
import { Toast, Dialog } from "vant";
export default {
  name: "ApproveDetail",
  data() {
    return {
      initData: {},
      appointStates: [
        { id: 0, type: "#ff976a", name: "待审批" },
        { id: 1, type: "#C0C0C0", name: "已取消" },
        { id: 2, type: "#07c160", name: "审批成功" },
        { id: 3, type: "#1989fa", name: "驳回" },
        // { type: "#FF0000", name: "红色" },
      ],
      openTypes: [
        // (0-门卡|1-指纹|2-密码|3-二维码)
        { value: 0, text: "门卡" },
        { value: 1, text: "指纹" },
        { value: 2, text: "密码" },
        { value: 3, text: "二维码" },
      ],
      operateTypes: [
        { id: 1, name: "审批" },
        { id: 2, name: "驳回" },
      ],
      rejectReason: "",
    };
  },
  created() {
    this.initData = this.$route.query;
  },
  computed: {
    showApplyTime(value) {
      return function (value) {
        console.log(value);
        return dayjs(parseInt(value)).format("YYYY-MM-DD HH:mm");
      };
    },
    showDate(item) {
      return function (item) {
        if (!item) {
          return "";
        } else {
          return (
            dayjs(parseInt(item.appointStartTime)).format("YYYY-MM-DD HH:mm") +
            "至" +
            dayjs(parseInt(item.appointEndTime)).format("YYYY-MM-DD HH:mm")
          );
        }
      };
    },
    //预约状态
    showAppointState(item) {
      return function (item) {
        return this.appointStates[item.appointState].name;
      };
    },
    // 预约开发方式
    showOpenType(value) {
      return function (value) {
        return this.openTypes[parseInt(value)].text;
      };
    },
  },
  methods: {
    //批量审批预约单
    async approveAppointment(operateType) {
      let data = {
        appointID: this.initData.appointID,
        operationType: operateType,
        peopleTel: md5(Math.random().toString().substr(2,11)),
        rejectReason: this.rejectReason,
        peopleID: this.$store.state.room.peopleID
      };
      let res = await this.$store.dispatch("examineApproveAppointment", data);
      if (res.success) {
        Toast.success(`${this.operateTypes[operateType - 1].name}成功！`);
        this.$router.go(-1);
      } else {
        Toast.fail(res.msg);
      }
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    // 审批
    async appoint() {
      await this.approveAppointment(this.operateTypes[0].id);
    },
    // 驳回
    async reject() {
      await this.approveAppointment(this.operateTypes[1].id);
    },
  },
};
</script>

<style scoped>
.van-nav-bar {
  background: #ba3939;
}
.navbar_title {
  color: #ffffff !important;
}
.nav-placeholder {
  height: 92px;
}
.container {
  width: 100%;
  padding: 0 30px;
  box-sizing: border-box;
}
.checkboxContent {
  height: fit-content;
  background: #ffffff;
  box-shadow: 4px 4px 27px 0px rgba(133, 133, 133, 0.3);
  margin-top: 28px;
}
.checkboxContent_nav_bar {
  width: 100%;
  height: 48px;
  line-height: 48px;
  text-align: center;
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #ffffff;
  background: #b73f3e;
}

.checkboxContent_body {
  height: fit-content;
  padding: 20px 15px 30px 15px;
  border: 1px Gainsboro solid;
  border-top: none;
  box-sizing: border-box;
}
.checkboxContent_body_msg {
  display: flex;
  height: 28px;
  line-height: 28px;
  margin-top: 12px;
  font-size: 27px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
}
.checkboxContent_body_msg:first-child {
  margin: 0;
}
.body_msg_title {
  width: fit-content;
}
.body_msg_text {
  flex: 1;
  text-align: end;
}
.operate {
  margin: 50px 0;
  background: #ffffff;
  box-shadow: 2px 3px 27px 0px rgba(10, 9, 10, 0.16);
}
.btn_items {
  display: flex;
}
.left_btn,.right_btn{
  font-size: .32rem;
}
.field_container {
  display: flex;
  padding-left: 20px;
  padding-right: 20px;
  height: 90px;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}
.van-field {
  max-height: 70px !important;
  line-height: 35px;
  /* line-height: ; */
  align-items: center;
  background: WhiteSmoke;
  opacity: 1;
  border-radius: 8px;
}
button {
  height: 65px;
  border-radius: 0;
}
.left_btn {
  border-top-left-radius: var(--btn-radius);
  border-bottom-left-radius: var(--btn-radius);
}
.right_btn {
  margin-left: 20px;
  border-top-right-radius: var(--btn-radius);
  border-bottom-right-radius: var(--btn-radius);
}
</style>